import apiClient from './api';

const inAppMessageService = {
  // Superadmin: Get all in-app messages
  getAdminInAppMessages: async () => {
    const response = await apiClient.get('/notifications/in-app-messages/', { skipCache: true });
    return response.data;
  },

  // Superadmin: Create new in-app message
  createAdminInAppMessage: async (payload) => {
    const response = await apiClient.post('/notifications/in-app-messages/', payload);
    return response.data;
  },

  // Superadmin: Update in-app message
  updateAdminInAppMessage: async (id, payload) => {
    const response = await apiClient.patch(`/notifications/in-app-messages/${id}/`, payload);
    return response.data;
  },

  // Superadmin: Delete in-app message
  deleteAdminInAppMessage: async (id) => {
    const response = await apiClient.delete(`/notifications/in-app-messages/${id}/`);
    return response.data;
  },

  // Superadmin: Search targetable users
  getTargetUsers: async (search = '') => {
    const response = await apiClient.get('/notifications/in-app-messages/target-users/', {
      params: { search },
    });
    return response.data;
  },

  // Superadmin: Get delivery recipients (seen and pending users)
  getMessageRecipients: async (id) => {
    const response = await apiClient.get(`/notifications/in-app-messages/${id}/recipients/`, {
      skipCache: true,
    });
    return response.data;
  },

  // End-user: Fetch active targeted in-app message for the current user
  getActiveInAppMessage: async () => {
    const response = await apiClient.get('/notifications/in-app-messages/active/', {
      skipCache: true,
    });
    return response.data;
  },

  // End-user: Dismiss message (record one-time delivery)
  dismissInAppMessage: async (id, { interactedWithCta = false } = {}) => {
    const response = await apiClient.post(`/notifications/in-app-messages/${id}/dismiss/`, {
      interacted_with_cta: interactedWithCta,
    });
    return response.data;
  },
};

export default inAppMessageService;
